import { twMerge } from "tailwind-merge";

type Props = {
  as?: React.ElementType;
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
};

export function InnerContentFrame({
  as = "div",
  children,
  className,
  innerClassName,
}: Props) {
  const Component = as;

  return (
    <Component
      className={twMerge("flex items-center justify-center", className)}
    >
      <div
        className={twMerge(
          "flex flex-col items-center justify-center w-full py-4 px-8 max-w-xl md:justify-start md:items-start md:p-8",
          innerClassName
        )}
      >
        {children}
      </div>
    </Component>
  );
}

export default InnerContentFrame;
